
import { Component, Vue, Prop } from 'vue-property-decorator'
import { setProductInfo } from '@/api/product/product'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import { getAccountStatistic } from '@/api/product/productAccount'
import { delObjEmptyKey } from '@/utils'
import { getProductInfo } from '@/api/product/productAccount'

@Component({
  name: 'ylpayExtra',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private product!: any

  private extraParam: any = {
    reuse_last_account_duration: 0
  }

  private rules: any = {
    reuse_last_account_duration: [
      {
        required: true,
        message: '请输入时间',
        trigger: 'blur'
      }
    ]
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }

  private async extraUpdate() {
    ;(this.$refs.extraParam as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        const data: any = {
          id: this.product.id,
          extra_param: {
            reuse_last_account_duration: Number(
              this.extraParam.reuse_last_account_duration
            )
          }
        }
        await setProductInfo(data).then(() => {
          this.$message({
            message: 'Modified successfully!',
            type: 'success'
          })
          this.flagStr()
          this.back()
        })
      } else {
        return false
      }
    })
  }

  // 产品详情
  private async getInfo() {
    const data = {
      id: this.product.id
    }
    await getProductInfo(data).then((res: any) => {
      if (res) {
        this.extraParam = {
          reuse_last_account_duration:
            res.extra_param.reuse_last_account_duration
        }
      } else {
        this.extraParam = {
          reuse_last_account_duration: 0
        }
      }
    })
  }

  mounted() {
    this.getInfo()
  }
}
